import {
  FREE_TRIAL_IPB_EMAIL_ERROR,
  UPDATE_EMAIL_FREE_TRIAL_IPB,
  RESEND_EMAIL_FREE_TRIAL_IPB,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

export const updateEmailAction = (transactionsId, email) => async (dispatch) => {
  const url = `/api/ipb/orders/sims/gifts/${transactionsId}/email`;

  try {
    const response = await axiosTokenInstance.put(url, { email });

    const { data, status } = response || {};

    dispatch({
      method: 'put',
      payload: data || {},
      status: status || null,
      type: UPDATE_EMAIL_FREE_TRIAL_IPB,
    });
  } catch (e) {
    console.error(e);
    dispatch({
      method: 'put',
      payload: e || {},
      status: e?.response?.status || null,
      type: FREE_TRIAL_IPB_EMAIL_ERROR,
    });
    throw e;
  }
};

export const resendEmailAction = (transactionsId) => async (dispatch) => {
  const url = `/api/ipb/orders/sims/free-trial/${transactionsId}/send-email`;

  try {
    const response = await axiosTokenInstance.post(url, {});

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || null,
      type: RESEND_EMAIL_FREE_TRIAL_IPB,
    });
  } catch (e) {
    console.error(e);
    dispatch({
      method: 'post',
      payload: e || {},
      status: e?.response?.status || null,
      type: FREE_TRIAL_IPB_EMAIL_ERROR,
    });
    throw e;
  }
};
